// ─── Dashboard Endpoints ──────────────────────────────────────────────────────

export const DASHBOARD = '/adminDashboard/getDashboardList';
export const DASHBOARD_FILTERS = '/adminDashboard/filters';
export const API_GET_ALL_DRIVER_LOCATION = '/adminDashboard/getAllDriver/';
export const API_GET_TRIPS_LOCATIONS = '/adminDashboard/getAllActiveTrip';
